import { useQuery } from "react-query";
import axios from "infra/http";
import { VotacaoDetalhes } from "../typings";

function useAssembleia(id: string) {
  return useQuery(
    [`/v1/votacao/${id}`],
    async () => {
      const res = await axios.get<VotacaoDetalhes>(`/v1/votacao/${id}`);

      return res.data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useAssembleia;
